import React from 'react';
import { Bar } from 'react-chartjs-2';

// Card 
import { Card, CardBody } from "reactstrap";

const styleCard ={
    borderRadius: '1rem'
}

const MonthlyChart = () => {
  const data = {
    labels: ["Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Leads",
        data: [10,12,15],
        backgroundColor: [
            "rgba(153, 102, 255, 0.7)",
            "rgba(153, 102, 255, 0.7)",
            "rgba(153, 102, 255, 0.7)"
        ],
        // backgroundColor: [
        //   "rgba(255, 99, 132, 0.7)",  // Red
        //   "rgba(54, 162, 235, 0.7)",  // Blue
        //   "rgba(255, 206, 86, 0.7)",  // Yellow
        //   "rgba(75, 192, 192, 0.7)",  // Green
        //   "rgba(153, 102, 255, 0.7)", // Purple
        //   "rgba(255, 159, 64, 0.7)",  // Orange
        //   "rgba(199, 99, 255, 0.7)",  // Violet
        //   "rgba(99, 255, 132, 0.7)",  // Lime
        //   "rgba(132, 255, 255, 0.7)", // Cyan
        //   "rgba(255, 132, 199, 0.7)", // Pink
        //   "rgba(192, 255, 75, 0.7)",  // Olive
        //   "rgba(64, 159, 255, 0.7)",  // Sky Blue
        // ],
        borderColor: "rgba(0, 0, 0, 0.1)", // Light border
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Monthly leads genration",
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: (value) => `${value}`,
          },
        },
      ],
    },
  };

  return (
    <>
      <Card style={styleCard}>
        <CardBody>
          <Bar data={data} options={options} height="282" />
        </CardBody>
      </Card>
    </>
  );
};

export default MonthlyChart;
